// React Components
import React, { useState, FC, ChangeEvent, FormEvent, MouseEvent } from "react";

import Axios from "axios";
// Own Components

import "./signupModalv2.scss";
// import Redux
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreators } from '../../../store';
import { RootState } from '../../../store/reducers';
import { freezScreenState, langValueState } from '../../../store/action-creators';
//  cookie functions
import { setCookie } from "../../../helper/cookieFunction";
// Api Services
import { authService } from "../../../services";
// React Router Components
import { Link, useNavigate } from "react-router-dom";// Mui Components
import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import CircularProgress from "@material-ui/core/CircularProgress";
import { withTranslation, useTranslation, Trans } from "react-i18next";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
// svg icons
import IMAGES from "../../../assets/images"
import TextField from "@mui/material/TextField";
import { styled } from "@mui/system";
import TabsUnstyled from "@mui/base/TabsUnstyled";
import TabsListUnstyled from "@mui/base/TabsListUnstyled";
import { buttonUnstyledClasses } from "@mui/base/ButtonUnstyled";
import TabUnstyled, { tabUnstyledClasses } from "@mui/base/TabUnstyled";
import Checkbox from "@material-ui/core/Checkbox";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import clsx from "clsx";
import Backdrop from "@mui/material/Backdrop";
import CircularIndeterminate from "../../../components/CircularIndeterminate";
import AppleLogin from "../../../components/AppleLogin/AppleLogin";
import FbLogin from "../../../components/FbLogin/FbLogin";
import LoginGoogle from "../../../components/LoginGoogle/LoginGoogle";
import Page from "../../../components/Page"

const blue = {
  50: "#F0F7FF",
  100: "#C2E0FF",
  200: "#80BFFF",
  300: "#66B2FF",
  400: "#3399FF",
  500: "#007FFF",
  600: "#0072E5",
  700: "#0059B2",
  800: "#004C99",
  900: "#003A75",
};
const Tab = styled(TabUnstyled)`
  font-family: IBM Plex Sans, sans-serif;
  color: white;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: bold;
  background-color: transparent;
  width: 100%;
  padding: 12px 12px;
  margin: 6px 6px;
  border: none;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  &:hover {
    background-color: ${blue[400]};
  }

  &:focus {
    color: #fff;
    border-radius: 3px;
    outline: 2px solid ${blue[200]};
    outline-offset: 2px;
  }

  &.${tabUnstyledClasses.selected} {
    background-color: ${blue[50]};
    color: ${blue[600]};
  }

  &.${buttonUnstyledClasses.disabled} {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const Tabs = styled(TabsListUnstyled)`
  min-width: 320px;
  background-color: ${blue[500]};
  border-radius: 8px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: space-between;
`;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  wrapper: {
    marginTop: "1.5rem",
    position: "relative",
  },
  buttonSuccess: {
    backgroundColor: green[500],
    "&:hover": {
      backgroundColor: green[700],
    },
  },
  fabProgress: {
    color: green[500],
    position: "absolute",
    top: -6,
    left: -6,
    zIndex: 1,
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  formControl: {
    width: "100%",
  },
}));

// function Alert(props) {
//   return <MuiAlert elevation={6} variant="filled" {...props} />;
// }

interface RegisterValuesInterface {
  first_name: string;
  last_name: string;
  email: string;
  gender: string;
  dob: string;
}
const SignupModal: FC = () => {
  const state = useSelector((state: RootState) => state.auth)
  const dispatch = useDispatch();
  const { langValueState, freezScreenState, alertMessageState, formDataState,userInfoState } = bindActionCreators(actionCreators, dispatch)
  const [age, setAge] = React.useState("");
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setAge(event.target.value);
  };
  const [fullWidth, setFullWidth] = React.useState(true);
  const [maxWidth, setMaxWidth] = React.useState("sm");
  const [checkTerm, setCheckTerm] = React.useState(false)
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  let [registered, setRegistered] = useState(false);
  const [countryCodeValues, setCountryCodeValues] = useState([]);
  const { t } = useTranslation();
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const buttonClassname = clsx({
    [classes.buttonSuccess]: success,
  });

  const [showPassword, setShowPassword] = useState(false);
  const [cShowPassword, setCShowPassword] = useState(false);



  const [alertMessage, setAlertMessage] = useState({
    open: false,
    message: "",
    alertSuccess: false,
  });
  const [snack, setSnack] = useState({
    vertical: "top",
    horizontal: "center",
  });
  const handleClickShowHidePassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = () => {
    setShowPassword(false);
  };
  const handleClickCShowPassword = () => {
    setCShowPassword(true);
  };

  const handleMouseCDownPassword = () => {
    setCShowPassword(false);
  };

  // const handleOpenLogin = () => {
  //   appDispatch({ type: "setLoginModal", loginModal: true });
  //   appDispatch({ type: "setSignUpModal", signUpModal: false });


  // };
  // const handleClose = () => {
  //   appDispatch({ type: "setSignUpModal", signUpModal: false });
  // }

  const [selectedDate, setSelectedDate] = useState({});
  const [RegisterValues, setRegisterValues] = useState<RegisterValuesInterface>({
    first_name: "",
    last_name: "",
    email: "",
    gender: "",
    dob: ""
  });
  // console.log(RegisterValues)
  const updateField = (prop: string | number) => (event: any) => {
    event.preventDefault();
    if (prop == 'gender') {
      // console.log(prop + ":" + event.currentTarget.id);
      setRegisterValues({ ...RegisterValues, [prop]: event.currentTarget.id });
    } else {
      // console.log(prop + ":" + event.target.value);
      setRegisterValues({ ...RegisterValues, [prop]: event.target.value });
    }

  };

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setLoading(true)
    freezScreenState(true);
    try {
      if (true) {
        let emailValidation = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
        if (!emailValidation.test(RegisterValues.email)) {
          setAlertMessage({
            open: true,
            message: t("Forms.Email-Format"),
            alertSuccess: false,
          });
          setLoading(false)
          freezScreenState(false);
          alertMessageState({
            type: "error",
            show: true,
            message: t("Forms.Email-Format"),
          });
          return;
        }
        const userObj = {
          first_name: RegisterValues.first_name,
          last_name: RegisterValues.first_name,
          email: RegisterValues.email,
          user_id: state.userInfo.id,
          dob: RegisterValues.dob,
          gender: RegisterValues.gender
        }
        const token = state.userInfo.token;
        const userId = state.userInfo.id
        const response = await authService.customerUpdateProfile(userObj, token, userId);
        console.log(response)
        if (response.data.success === true) {
          console.log("success true ",response.data.data)
          localStorage.setItem(`userInfo`, JSON.stringify(response.data.data));
          setCookie("Profile", JSON.stringify(response.data.data),30); // set cookie by Profile bcz we are using it by Profile on shop and pay
          userInfoState(response.data.data)
          window.location.replace(state.shopUrl)
        } else if (response.data.success === false) {
          setLoading(false);
          freezScreenState(false);
          alertMessageState({
            type: "error",
            show: true,
            message: response.data.data,
          });
        }
        freezScreenState(false);

      } else {
        alertMessageState({
          type: "error",
          show: true,
          message: t("Login.plz-fill-required-fields"),
        });
        freezScreenState(false);
        setLoading(false)
        return;
      }
    } catch (e) {
      setLoading(false);
      freezScreenState(false);
      alertMessageState({
        type: "error",
        show: true,
        message: e
      });
      console.log(e)

    }
  };

  const handleSkip = () => {
    window.location.replace(state.shopUrl)
  }



  return (
    <div>

      <Dialog
        fullWidth={fullWidth}
        // maxWidth={maxWidth}
        open={true}
        BackdropProps={{ invisible: true }}
      // onClose={handleClose}

      >
        {loading && (
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme:any) => theme.zIndex.drawer + 1 }}
            open={loading}
          >
            <CircularIndeterminate />
          </Backdrop>
        )}
        <DialogContent>
          <Page title="account">   <div
            className={`${state.langValue === "ar" ? "directionRtl" : ""}`}
            id="signupModalMain"
          >
            <div className="row ">
              <div className="col-md-12 d-flex justify-content-between classforPaddinglogo">
                <img src={IMAGES.enabill} alt="enabill-logo" />
                <div>
                  {state.langValue == "ar" ? (
                    <Button
                      className="px-5 mx-2 arabicBtn"
                      variant="contained"
                      onClick={() => langValueState('en')}
                    >
                      English
                    </Button>
                  ) : (
                    <Button
                      className="px-5  arabicBtn"
                      variant="contained"
                      onClick={() => langValueState('ar')}
                    >
                      العربيه
                    </Button>
                  )}
                </div>
              </div>
            </div>
            <h1
              className={`familyManrope800 mt-2 mb-0 ${state.langValue === "ar" ? "d-flex text-right" : ""
                }`}
            >
              {t("Forms.My-Account")}
            </h1>
            <div className="tabNavigation">
              <form onSubmit={handleSubmit}>

                <div
                  className={`classforPaddingTextfield ${state.langValue === "ar" ? "classforArabic" : ""
                    }`}
                >
                  <div className="row">
                    <div className="col-md-6">
                      <TextField
                        className="mt-3"
                        id="register_fname"
                        label={t("Forms.First-Name")}
                        type="text"
                        name="first_name"
                        value={RegisterValues.first_name}
                        onChange={updateField("first_name")}
                        variant="outlined"
                      />
                    </div>
                    <div className="col-md-6">
                      <TextField
                        id="register_lname"
                        name="last_name"
                        value={RegisterValues.last_name}
                        onChange={updateField("last_name")}
                        type="text"
                        label={`${t("Forms.Last-Name")} `}
                        className="mt-3"
                        variant="outlined"
                      />
                    </div>
                  </div>

                  <TextField
                    className="mt-3"
                    id="register_email"
                    name="email"

                    value={RegisterValues.email}
                    onChange={updateField("email")}
                    label={t("Forms.email")}
                    type="email"
                    variant="outlined"

                  />
                  <TextField
                    id="dob-field"
                    name="dob"
                    value={RegisterValues.dob}
                    onChange={updateField("dob")}
                    type="date"
                    variant="outlined"
                    className="mt-3"
                    label={t("Forms.dob")}
                    // id="DoB"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment
                          position="start"
                          className=""
                        ></InputAdornment>
                      ),
                    }}
                  />
                </div>

                <div className="row mt-1">
                  <div className="col-md-12">
                    <p
                      className={`px-1 m-0 familyManrope600 ${state.langValue === "ar" ? "text-right d-flex" : ""
                        }`}
                    >
                      {t("Forms.gender")}:
                    </p>
                    <div className="addTipMain tabNavigation">
                      <TabsUnstyled>
                        <Tabs
                          defaultValue={RegisterValues.gender}
                          onChange={updateField("gender")}
                        >
                          <Tab id="male"
                            onClick={updateField("gender")}
                          >
                            <div className=" d-flex flex-column align-items-center justify-content-center ">
                              <p className="price familyManrope800 m-0 ">
                                {t("Forms.male")}
                              </p>
                            </div>
                          </Tab>
                          <Tab id="female"
                            onClick={updateField("gender")}
                          >
                            <div className=" d-flex flex-column align-items-center justify-content-center ">
                              <p className="price  familyManrope800 m-0">
                                {t("Forms.female")}
                              </p>
                            </div>
                          </Tab>

                        </Tabs>
                      </TabsUnstyled>
                    </div>
                  </div>
                </div>



                <div className="row mt-2">
                  <div className="col-12 mt-1">
                    <Button
                      className=" blackBtn fontSize1rem bgEnabill py-3 familyManrope800 "
                      variant="contained"
                      type="submit"
                    >

                      {t("Forms.Save")}

                    </Button>
                  </div>
                </div>
                <p onClick={handleSkip} className="py-3 text-center cursorPointer text-primary familyManrope800">{t("Forms.Skip")}</p>
              </form>


            </div>
          </div></Page>

        </DialogContent>
      </Dialog>
    </div>
  );
};
export default withTranslation()(SignupModal);
